/**
 * @file ResetRequestPage.tsx
 * @description Страница /reset/request (phase08.5 shadcn; phase19.29 — тема
 * и логотип Commora через CommoraAuthShell).
 */

import { Loader2 } from "lucide-react";
import { type FormEvent, useState } from "react";
import { Link as ReactRouterLink } from "react-router";

import { CommoraAuthShell } from "../../components/brand/CommoraAuthShell";
import { EditorialCard } from "../../components/ui/EditorialCard";
import { Alert } from "../../components/ui/alert";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { ApiError } from "../../lib/api-client";
import { requestPasswordReset } from "../../lib/api-auth-reset";

export function ResetRequestPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await requestPasswordReset(email.trim());
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось отправить запрос");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <CommoraAuthShell tabTitle="Восстановление пароля">
      <EditorialCard floating className="w-full">
        <EditorialCard.Body>
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1 items-center text-center">
              <h1 className="type-page-title text-on-surface">
                Восстановление пароля
              </h1>
              <p className="text-sm text-on-surface-variant">
                Укажите email учётной записи — мы отправим ссылку для назначения нового пароля.
              </p>
            </div>

            {done ? (
              <Alert severity="success" role="status">
                Если такая учётная запись существует, мы отправили на неё письмо со
                ссылкой. Ссылка действует 1 час.
              </Alert>
            ) : (
              <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <Label htmlFor="reset-email">Email</Label>
                  <Input
                    id="reset-email"
                    type="email"
                    autoComplete="username"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={submitting}
                  />
                </div>

                {error ? <Alert severity="error">{error}</Alert> : null}

                <Button type="submit" disabled={submitting} className="w-full">
                  {submitting ? (
                    <>
                      <Loader2 className="size-4 animate-spin" />
                      Отправляем…
                    </>
                  ) : (
                    "Отправить ссылку"
                  )}
                </Button>
              </form>
            )}

            <div className="text-center">
              <ReactRouterLink to="/login" className="text-sm text-primary hover:underline">
                ← Вернуться к входу
              </ReactRouterLink>
            </div>
          </div>
        </EditorialCard.Body>
      </EditorialCard>
    </CommoraAuthShell>
  );
}
